import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
export var MenuItem = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  border-radius: 0.25rem;\n  background-color: ", ";\n  font-weight: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  @media only screen and (max-width: ", ") {\n    padding: 0.125rem .5rem;\n  } \n"])), function (props) {
  return props.active ? props.theme.colors.grey : 'none';
}, function (props) {
  return props.active ? 'bold' : 'normal';
}, function (props) {
  return props.theme.colors.grey;
}, function (props) {
  var _props$theme$breakpoi;

  return ((_props$theme$breakpoi = props.theme.breakpoints) === null || _props$theme$breakpoi === void 0 ? void 0 : _props$theme$breakpoi.sm) && '576px';
});
MenuItem.defaultProps = {
  active: false
};
export default styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  align-items: center;\n\n  li, a {\n    margin: 0 0.5rem;\n    color: ", ";\n\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  @media only screen and (max-width: ", ") {\n    overflow-x: scroll;\n    padding: 1rem 0;\n\n    li, a {\n      margin: 0 0.1rem;\n\n      &:first-child {\n        margin-left: 0;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.colors.dark;
}, function (props) {
  var _props$theme$breakpoi2;

  return ((_props$theme$breakpoi2 = props.theme.breakpoints) === null || _props$theme$breakpoi2 === void 0 ? void 0 : _props$theme$breakpoi2.sm) && '576px';
});